export const PAYPHONE_TOKEN = process.env.REACT_APP_PAYPHONE_TOKEN;
export const PAYPHONE_AUTHORIZATION_TOKEN = `Bearer ${process.env.REACT_APP_PAYPHONE_TOKEN}`;
